import { render, staticRenderFns } from "./NoSkills.vue?vue&type=template&id=78e0412d&scoped=true&"
import script from "./NoSkills.vue?vue&type=script&lang=js&"
export * from "./NoSkills.vue?vue&type=script&lang=js&"
import style0 from "./NoSkills.vue?vue&type=style&index=0&id=78e0412d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0412d",
  null
  
)

export default component.exports